import { render, staticRenderFns } from "./token-manager.vue?vue&type=template&id=0f3ec320&scoped=true"
import script from "./token-manager.vue?vue&type=script&lang=js"
export * from "./token-manager.vue?vue&type=script&lang=js"
import style0 from "./token-manager.vue?vue&type=style&index=0&id=0f3ec320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3ec320",
  null
  
)

export default component.exports